import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import RatingRenderer from 'payroll/components/CellRenderers/RatingRenderer';

const useRatingColumn = ({ updateEmployeeRating }) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return RatingRenderer({
        rowData: params.data,
        columnData: { onChangeRating: updateEmployeeRating }
      });
    },
    [updateEmployeeRating]
  );

  return useMemo(
    () => ({
      field: 'rating',
      headerName: t('rating'),
      width: 130,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useRatingColumn;
